export default {
  state: () => ({
    example: false,
    displayMobileNav: false,
    toast: {},
    showSpinner: false
  })
}



// WEBPACK FOOTER //
// ./src/app/store/misc/config.js